import { DadosFormService } from "./../doador/doador.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import {
  ConfirmacaoComponent,
  ConfirmDialogModel,
} from "../dados-form/confirmacao/confirmacao.component";
import { TecidoList } from "../tecidos-captados/tecido";
import { TecidoStore } from "../tecidos-captados/tecido.store";
import { TecidosCaptadosService } from "../tecidos-captados/tecidos-captados.service";
import { TecidosComponent } from "../tecidos-captados/tecidos/tecidos.component";
import { Pagination } from "./coletor";
import { ColetorService } from "./coletor.service";

// import { DadosForm } from './dados-form';

@Component({
  selector: "app-coletor",
  templateUrl: "./coletor.component.html",
  styleUrls: ["./coletor.component.css"],
})
export class ColetorComponent implements OnInit {
  @Input() captacao: FormGroup;
  @Input() tecidoCaptado: FormGroup;
  @Input() captacaoTecidosCaptados: TecidoList[];
  @Input() editarWeb: boolean;
  @Input() finalizarEdColeta: boolean;
  @Input() termoValido: boolean;
  @Input() desabilitarBotoes: boolean;
  @Input() idCaptacao: number;
  @Output() onFichaValidaChange = new EventEmitter<boolean>();
  @Output() onFinalizarColeta = new EventEmitter<boolean>();
  tecidoDuroDescartado: String =
    "descartados, após a coleta dos tecidos moles com potencial de obtenção de células-tronco, ou";
  tecidoDuroDoado: string =
    "doados para o Banco de Dentes devidamente habilitado para serem utilizados em pesquisa e/ou para fins didáticos.";
  destinoMaterialDescartado: string = "descartado, ou";
  destinoMaterialDoado: string = "doado para ser utilizado em pesquisa";
  doacaoPesquisaSim =
    "quero ser informado caso o material biológico doado seja utilizado em alguma pesquisa;";
  doacaoPesquisaNao =
    "não quero ser informado caso o material biológico doado seja utilizado em alguma pesquisa";

  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  result: string = "";

  constructor(
    private tecidosCaptados: MatDialog,
    public store: TecidoStore,
    private fb: FormBuilder,
    private tecidoService: TecidosCaptadosService,
    private coletorService: ColetorService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private doadorService: DadosFormService
  ) {}

  ngOnInit(): void {
    this.tecidoService
      .findAll("50", "0", "")
      .subscribe((res: Pagination<TecidoList[]>) => {
        this.store.tecidos = res.results;
      });
    this.validateAllFormFields(this.captacao);
  }

  ngOnDestroy() {
    this.store.relacionado = [];
  }

  addTecidos() {
    event.preventDefault();
    const tecidosCaptadosModal = this.tecidosCaptados.open(TecidosComponent, {
      data: {
        tecidos: this.tecidoCaptado.get("tecidos"),
        tecidos2: this.captacaoTecidosCaptados,
      },
    });
    tecidosCaptadosModal.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  removerTecido(tecido) {
    let control = this.tecidoCaptado as FormGroup;
    let array = control.get("tecidos") as FormArray;

    this.store.tecidos = [...this.store.relacionado, tecido];

    this.store.relacionado = this.store.tecidos.filter(
      (tec) => tec.codigo !== tecido.codigo
    );

    for (let i = 0; i < array.controls.length; i++) {
      if (
        array.at(i).get("codigo").value === tecido.codigo &&
        array.at(i).get("acao").value === "Inserir"
      ) {
        array.at(i).patchValue({
          acao: "NaoInserir",
        });
      }
    }
  }

  // captacaoTecidosCaptados;
  excluirTecidoCaptado(tecidoCaptado) {
    let control = this.tecidoCaptado as FormGroup;
    let array = control.get("tecidos") as FormArray;

    for (let i = 0; i < this.captacaoTecidosCaptados.length; i++) {
      if (
        this.captacaoTecidosCaptados[i].codigoCaptacao === null &&
        this.captacaoTecidosCaptados[i].acao === "Inserir" &&
        this.captacaoTecidosCaptados[i].codigo === tecidoCaptado.codigo
      ) {
        this.captacaoTecidosCaptados.splice(i, 1);
      } else if (
        this.captacaoTecidosCaptados[i].codigoCaptacao ===
          tecidoCaptado.codigoCaptacao &&
        this.captacaoTecidosCaptados[i].codigoCaptacao !== null
      ) {
        this.captacaoTecidosCaptados[i].acao = "Remover";
      }
      array.reset();
    }
  }

  finalizarColetaFlag() {
    this.coletorService.sendClose("0");
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  finalizarColeta() {
    const message = `Deseja finalizar a coleta?`;

    const dialogData = new ConfirmDialogModel(
      "Finalizar coleta",
      message,
      "Finalizar"
    );

    const dialogRef = this.dialog.open(ConfirmacaoComponent, {
      maxWidth: "400px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      this.result = dialogResult;
      if (this.result == "true") {
        this.desabilitarBotoes = true;
        this.finalizarEdicaoColeta();
        this.onFichaValidaChange.emit(true);
        this.desabilitarBotoes = true;
        this.onFinalizarColeta.emit(true);
        return;
      }
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  finalizarEdicaoColeta() {
    this.desabilitarBotoes = true;
    this.doadorService
      .updateFlag(this.idCaptacao, "coleta", this.dataHoraAtual())
      .subscribe((res) => {
        this.openSnackBar("Coleta finalizado com sucesso!", "Fechar");
        // this.desabilitarColeta();
        this.finalizarEdColeta = false;
        this.termoValido = true;
        this.desabilitarBotoes = true;
        this.captacao.disable();
        return;
      });
  }

  desabilitarColeta() {
    this.captacao.get("transportadora").disable();
    this.captacao.get("dataColeta").disable();
    this.captacao.get("inicioProcedimento").disable();
    this.captacao.get("fimProcedimento").disable();
    this.captacao.get("localCaptacao").disable();
    this.captacao.get("descricaoLocalColeta").disable();
    this.captacao.get("profilaxia").disable();
    this.captacao.get("bochechos").disable();
    this.captacao.get("anestesicoTopico").disable();
    this.captacao.get("anestesicoInjetavel").disable();
    this.captacao.get("anestesicoVasoConstritor").disable();
    this.captacao.get("clivagem").disable();
    this.captacao.get("odontoseccao").disable();
    this.captacao.get("remocaoRestauracoes").disable();
    this.captacao.get("remocaoCaries").disable();
    this.captacao.get("historiaMedicaSocial1Flag").disable();
    this.captacao.get("historiaMedicaSocial2Flag").disable();
    this.captacao.get("historiaMedicaSocial3Flag").disable();
    this.captacao.get("historiaMedicaSocial4Flag").disable();
    this.captacao.get("historiaMedicaSocial5Flag").disable();
    this.captacao.get("historiaMedicaSocial6Flag").disable();
    this.captacao.get("historiaMedicaSocial7Flag").disable();
    this.captacao.get("historiaMedicaSocial8Flag").disable();
    this.captacao.get("historiaMedicaSocial9Flag").disable();
    this.captacao.get("historiaMedicaSocial10Flag").disable();
    this.captacao.get("historiaMedicaSocial11Flag").disable();
    this.captacao.get("historiaMedicaSocial12Flag").disable();
    this.captacao.get("historiaMedicaSocial13Flag").disable();
    this.captacao.get("observacoesHistoricoSaude").disable();
    this.captacao.get("exameFisico1Flag").disable();
    this.captacao.get("exameFisico2Flag").disable();
    this.captacao.get("exameFisico3Flag").disable();
    this.captacao.get("exameFisico4Flag").disable();
    this.captacao.get("exameFisico5Flag").disable();
    this.captacao.get("observacoesExameFisico").disable();
    this.captacao.get("dataExamesSanguineos").disable();
    this.captacao.get("hemograma").disable();
    this.captacao.get("paiFlag").disable();
    this.captacao.get("trypanosoma_1").disable();
    this.captacao.get("trypanosoma_2").disable();
    this.captacao.get("citomegalovirus_1").disable();
    this.captacao.get("citomegalovirus_2").disable();
    this.captacao.get("hiv_1").disable();
    this.captacao.get("hiv_2").disable();
    this.captacao.get("htlv").disable();
    this.captacao.get("hepatiteB_1").disable();
    this.captacao.get("hepatiteB_1").disable();
    this.captacao.get("hepatiteB_2").disable();
    this.captacao.get("hepatiteB_3").disable();
    this.captacao.get("hepatiteB_4").disable();
    this.captacao.get("hepatiteC_1").disable();
    this.captacao.get("treponemaPallidum_1").disable();
    this.captacao.get("treponemaPallidum_2").disable();
    this.captacao.get("toxoplasmaGondii_1").disable();
    this.captacao.get("toxoplasmaGondii_2").disable();
    this.captacao.get("malaria_1").disable();
    this.captacao.get("malaria_2").disable();
    this.captacao.get("sorologia").disable();
    this.captacao.get("captacao.observacoesDadosLaboratoriais").disable();
    this.captacao.get("observacoesDadosLaboratoriais").disable();
    this.captacao.get("destinoMaterialBiologico").disable();
    this.captacao.get("doacaoPesquisa").disable();
    this.captacao.get("destinoTecidosDuros").disable();
    this.captacao.get("sARS_CoV2_Covid_19_igg").disable();
    this.captacao.get("sARS_CoV2_Covid_19_igm").disable();
    this.captacao.get("sARS_CoV2_Covid_pcr").disable();
    this.captacao.get("destinoTecidosDuros").disable();
    this.captacao.get("destinoMaterialBiologico").disable();
    this.captacao.get("doacaoPesquisa").disable();

    this.captacao.get("sifilisvdrl").disable();
    this.captacao.get("pcrqualitativocmv").disable();
    this.captacao.get("pcrquantitativohepatiteb").disable();
    this.captacao.get("pcrqualitativohepatitec").disable();
    this.captacao.get("pcrqualitativohiv").disable();
    this.captacao.get("pcrhtlv1").disable();
    this.captacao.get("pcrhtlv2").disable();
    this.captacao.get("pcrqualitativoepsteinbarr").disable();
    this.captacao.get("examesadicionais").disable();
    this.captacao.get("outrosAnestesicoVasoConstritor").disable();
    this.captacao.get("porcentagemOutrosAnestesicoVasoConstritor").disable();
    this.captacao.get("outrosAnestesicoVasoConstritorDesc").disable();
    this.desabilitarBotoes = true;
  }

  dataHoraAtual(): string {
    let data = new Date();
    let dataLocal = data.toLocaleDateString();
    let horaLocal = data.toLocaleTimeString();

    let dataHoraAtual = dataLocal + " " + horaLocal;
    return dataHoraAtual;
  }

  resetField(campo) {
    this.captacao.get(campo).reset();
  }

  validaDoador() {
    if (
      this.captacao.get("destinoTecidosDuros").value == "1" &&
      this.captacao.get("destinoMaterialBiologico").value == "1" &&
      !this.captacao.get("doacaoPesquisa").value
    ) {
      this.captacao.get("doacaoPesquisa").setValidators([Validators.required]);
      if (this.captacao.get("doacaoPesquisa").value == "") {
        this.captacao.get("doacaoPesquisa").setErrors({ required: true });
      }
      return;
    } else {
      this.captacao.get("doacaoPesquisa").setValidators([]);
      this.captacao.get("doacaoPesquisa").setErrors({ required: false });
    }
  }
}
